export default __webpack_public_path__ + "static/media/GetReady.31c6ec1c.png";